/**
 * Hub 详情页按 layout 区分的视觉与文案配置（骨架相同，气质不同）
 */
var LAYOUT_PROFILE_STRINGS = {
  zh: {
    review: {
      layoutClass: 'hub-layout-review',
      headerHint: '含实测结论、提示词示例、优缺点对照和与其他模型的选型建议。',
      tldrLabel: '结论',
      tldrTitle: '测评结论',
      tldrDesc: '先看适合什么场景，再对照下文示例和提示词。',
      faqLabel: '问答',
      faqTitle: '常见问题',
      intentsLabel: '场景',
      conclusionLabel: '总结',
      conclusionTitle: '总结与下一步',
      sideCtaKicker: '推荐入口',
      sideCtaDesc: '把文中的提示词和步骤直接拿去 Miral 试一版。',
      navLabel: '在本文中',
      showHeroImage: false,
      showProsConsHighlight: true
    },
    alternatives: {
      layoutClass: 'hub-layout-alternatives',
      headerHint: '对比 Midjourney、Stable Diffusion 等替代入口，按你的实际需求选型。',
      tldrLabel: '对比',
      tldrTitle: '选型速览',
      tldrDesc: '先确定你要艺术探索还是商业出片，再对照下表。',
      faqLabel: '问答',
      faqTitle: '选型疑问',
      intentsLabel: '选型',
      conclusionLabel: '下一步',
      conclusionTitle: '总结与下一步',
      sideCtaKicker: '先试这一版',
      sideCtaDesc: '同页切换模型，比 Discord 或本地部署省事。',
      navLabel: '对比章节',
      showHeroImage: false,
      showComparePills: true
    },
    'prompt-guide': {
      layoutClass: 'hub-layout-prompt-guide',
      headerHint: '专注带标题、卖点和排版的海报类 prompt 写法，可复制示例直接试。',
      tldrLabel: '提示词',
      tldrTitle: '写法要点',
      tldrDesc: '先看清适合什么海报类型，再复制下方示例微调。',
      faqLabel: '问答',
      faqTitle: '常见问题',
      intentsLabel: '提示词',
      conclusionLabel: '去试',
      conclusionTitle: '总结与下一步',
      sideCtaKicker: '去试 prompt',
      sideCtaDesc: '复制示例提示词，在 GPT Image 里连出 2–3 版再定稿。',
      navLabel: '在本文中',
      showHeroImage: false,
      highlightPrompts: true
    },
    'how-to': {
      layoutClass: 'hub-layout-how-to',
      headerHint: '按步骤处理图片素材；建议先看适用场景，再上传试一版。',
      tldrLabel: '速览',
      tldrTitle: '快速结论',
      tldrDesc: '确认你的素材类型是否适合，再按步骤操作。',
      faqLabel: '帮助',
      faqTitle: '常见疑问',
      intentsLabel: '技巧',
      conclusionLabel: '完成',
      conclusionTitle: '总结与下一步',
      sideCtaKicker: '免费试用',
      sideCtaDesc: '上传一张小图先试效果，满意再处理正式素材。',
      navLabel: '操作章节',
      showHeroImage: false,
      showWorkflowStrip: true
    }
  },
  en: {
    review: {
      layoutClass: 'hub-layout-review',
      headerHint: 'Includes practical takeaways, prompt examples, pros and cons, and model selection notes.',
      tldrLabel: 'Verdict',
      tldrTitle: 'Review summary',
      tldrDesc: 'Check the best-fit use cases first, then compare the workflow below.',
      faqLabel: 'FAQ',
      faqTitle: 'Common questions',
      intentsLabel: 'Guide',
      conclusionLabel: 'Summary',
      conclusionTitle: 'Conclusion and next step',
      sideCtaKicker: 'Recommended entry',
      sideCtaDesc: 'Take the prompts and checklist into Miral for a quick test.',
      navLabel: 'In this article',
      showHeroImage: false,
      showProsConsHighlight: true
    },
    alternatives: {
      layoutClass: 'hub-layout-alternatives',
      headerHint: 'Compares browser-based alternatives and helps you pick by actual use case.',
      tldrLabel: 'Compare',
      tldrTitle: 'Selection summary',
      tldrDesc: 'Decide whether you need art exploration, commercial output, text control, or local-style generation.',
      faqLabel: 'Q&A',
      faqTitle: 'Selection questions',
      intentsLabel: 'Pick',
      conclusionLabel: 'Next',
      conclusionTitle: 'Conclusion and next step',
      sideCtaKicker: 'Try this first',
      sideCtaDesc: 'Switch models in one place and compare results quickly.',
      navLabel: 'Comparison sections',
      showHeroImage: false,
      showComparePills: true
    },
    'prompt-guide': {
      layoutClass: 'hub-layout-prompt-guide',
      headerHint: 'Focused on prompt structure for posters, product visuals, readable text, and social covers.',
      tldrLabel: 'Prompt',
      tldrTitle: 'Prompt essentials',
      tldrDesc: 'Copy a pattern, adjust the subject and platform, then generate several versions.',
      faqLabel: 'FAQ',
      faqTitle: 'Common questions',
      intentsLabel: 'Prompt',
      conclusionLabel: 'Try',
      conclusionTitle: 'Conclusion and next step',
      sideCtaKicker: 'Try the prompt',
      sideCtaDesc: 'Copy a prompt example into Miral and refine from the best output.',
      navLabel: 'In this article',
      showHeroImage: false,
      highlightPrompts: true
    },
    'how-to': {
      layoutClass: 'hub-layout-how-to',
      headerHint: 'Step-by-step workflow for cleaning or correcting an existing image.',
      tldrLabel: 'Quick',
      tldrTitle: 'Quick summary',
      tldrDesc: 'Confirm the source image type first, then process a small test file.',
      faqLabel: 'Help',
      faqTitle: 'Common questions',
      intentsLabel: 'Tips',
      conclusionLabel: 'Done',
      conclusionTitle: 'Conclusion and next step',
      sideCtaKicker: 'Open the tool',
      sideCtaDesc: 'Upload one small image first, review the result, then process the final asset.',
      navLabel: 'Workflow sections',
      showHeroImage: false,
      showWorkflowStrip: true
    }
  }
}

var DEFAULT_LOCALE = 'en'

function normalizeLocale(locale) {
  var lang = String(locale || '').toLowerCase()
  if (LAYOUT_PROFILE_STRINGS[lang]) return lang
  return DEFAULT_LOCALE
}

function getHubLayoutProfile(article, locale) {
  var lang = normalizeLocale(locale)
  var profiles = LAYOUT_PROFILE_STRINGS[lang] || LAYOUT_PROFILE_STRINGS.en
  if (!article) return Object.assign({}, profiles.review)
  var layout = article.layout || 'review'
  return Object.assign({}, profiles[layout] || profiles.review, article.layoutProfile || {})
}

module.exports = {
  HUB_LAYOUT_PROFILES: LAYOUT_PROFILE_STRINGS,
  getHubLayoutProfile: getHubLayoutProfile
}
